const router = [
  {
    path: '/deviceMap',
    name: 'deviceMap',
    component: () => import('@/views/device/map.vue'),
    meta: {
      hasBack: true,
      backUrl: '/projectdevice',
      title: '设备地图'
    }
  },
  {
    path: '/projectdevice',
    name: 'projectdevice',
    component: () => import('@/views/device/ProjectDeviceList.vue'),
    meta: {
      title: '项目设备'
    }
  }
]
export default router
